import React, { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import OTPModal from "../JoinWaitlist/OTPModal";

import { useNavigate } from "react-router-dom";
import apiClient from "../../utils/apiClient";
import { sendOtp } from "../../services/userService";
import { countryList } from "../../utils/utils";
import { makeCall } from "../../services/flowService";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .min(1, "Name must be atleast 1 character")
    .required("Name is required"),
  countryCode: Yup.string().required("Country Code is required"),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number is not valid")
    .required("Phone number is required"),
  category: Yup.string().required("Category is required"),
});

const MakeCallPopup = ({ toggleMakeCallPopup, finalData }) => {
  const [loading, setLoading] = useState();
  const [msg, setMsg] = useState("");

  const navigate = useNavigate();

  return (
    <>
      <div
        onClick={toggleMakeCallPopup}
        className="absolute z-50 top-0 right-0 w-screen h-screen bg-transparent"></div>
      <div className="absolute right-14 top-20 z-50 my-4 text-base list-none text-black bg-white divide-y divide-gray-100 rounded-md shadow-lg dark:bg-gray-700 dark:divide-gray-600 w-[30rem] text-left p-4 border border-slate-300">
        <div className="">
          <Formik
            initialValues={{
              name: "",
              countryCode: "+91",
              phone: "",
              category: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              setMsg("");
              setLoading(true);
              const data = {
                user_name: values.name,
                user_phone: values.countryCode + values.phone,
                category: values.category,
                flow: finalData,
              };

              makeCall(data).then((response) => {
                setLoading(false);
                setMsg(response.data?.message);
              });
            }}>
            {({ errors, touched, values }) => (
              <Form className="space-y-4">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-gray-700">
                    <span className="text-red-500">*</span>Name
                  </label>
                  <Field
                    name="name"
                    type="text"
                    className={
                      "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" +
                      (errors.name && touched.name ? " border-red-500" : "")
                    }
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>
                <div className="flex w-full gap-3">
                  <div className="w-[50%]">
                    <label
                      htmlFor="countryCode"
                      className="block text-sm font-medium text-gray-700">
                      <span className="text-red-500">*</span>Phone
                    </label>
                    <Field
                      as="select"
                      name="countryCode"
                      className={
                        "mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" +
                        (errors.countryCode && touched.countryCode
                          ? " border-red-500"
                          : "")
                      }>
                      {countryList.map((country, index) => (
                        <option key={country.code} value={country.dial_code}>
                          {`${country.flag} (${country.dial_code})      ${country.code} ${country.name}`}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="countryCode"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>

                  <div className="w-full relative top-3 flex flex-col gap-2">
                    <label
                      htmlFor="phone"
                      className="block text-sm font-medium text-gray-700">
                      {" "}
                    </label>
                    <div className="gap-3">
                      <Field
                        name="phone"
                        type="number"
                        className={
                          "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" +
                          (errors.phone && touched.phone
                            ? " border-red-500"
                            : "")
                        }
                      />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="text-red-500 text-sm mt-1"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="category"
                    className="block text-sm font-medium text-gray-700">
                    <span className="text-red-500">*</span>Category
                  </label>
                  <Field
                    name="category"
                    type="text"
                    className={
                      "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" +
                      (errors.category && touched.category
                        ? " border-red-500"
                        : "")
                    }
                  />
                  <ErrorMessage
                    name="category"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>
                <div className="w-full flex flex-col gap-2 justify-center z-30">
                  <button
                    type="submit"
                    className={`border-[1px] rounded text-white mb-10 px-5 py-[6px]  w-full ${
                      loading
                        ? "bg-gray-300 text-slate-600"
                        : "bg-black border-black"
                    }`}
                    disabled={loading}>
                    Call
                  </button>
                  <div>{msg}</div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default MakeCallPopup;
